export default __webpack_public_path__ + "static/media/fish_hover.1585da35.png";